import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../types/state';
import { getJobExecutionLogs } from '../redux/actions/jobs';

const useJobLogs = (clientId, date) => {
  const { logs, loading } = useSelector((state: StoreState) => ({
    logs: state.jobs.logs,
    loading: state.jobs.logsLoading,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !['loading', 'failed'].includes(loading) &&
      (!logs ||
        !logs[date] ||
        (clientId && !logs[date][clientId]) ||
        (!clientId && !logs[date]['all']))
    ) {
      dispatch(getJobExecutionLogs(clientId, date));
    }
  }, [clientId, date, logs, loading, dispatch]);

  return { logs: logs && logs[date] && logs[date][clientId || 'all'], loading };
};

export default useJobLogs;
